import { Base } from '@studiometa/js-toolkit';

/**
 * TopBar.
 *
 */
export default class TopBar extends Base {
  index = 0;

  static config = {
    name: 'TopBar',
    refs: ['wrapper'],
    options: {
      delay: Number,
      size: Number,
    },
  };

  /**
   *
   */
  mounted() {
    this.initInterval();
  }

  /**
   * When entering component -> stop animations
   */
  onMouseenter() {
    clearInterval(this.intervalId);
  }

  /**
   * When leaving component
   */
  onMouseleave() {
    this.initInterval();
  }

  /**
   *
   */
  initInterval() {
    this.intervalId = setInterval(() => {
      this.index += 1;
      this.switchState();
    }, this.$options.delay * 1000);
  }

  /**
   * Slide animations + dots opacity
   * @returns {void}
   */
  switchState() {
    if (this.index >= this.$options.size) {
      this.index = 0;
    }

    this.$refs.wrapper.style.transform = `translateY(-${100 * this.index}%)`;
  }
}
